import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export interface AppNotification {
  id: string;
  userId: string;
  type:
    | "order.assigned"
    | "order.rejected"
    | "order.hours_submitted"
    | "order.approved"
    | "payroll.approved"
    | "pu_project.assigned"
    | "absence.updated"
    | "absence.approved"
    | "absence.rejected"
    | "attendance.part_day_absence";
  message: string;
  href?: string;
  createdAt: string;
  read: boolean;
}

interface NotificationState {
  items: AppNotification[];
  addNotification: (notification: Omit<AppNotification, "id" | "createdAt" | "read">) => void;
  markAsRead: (id: string) => void;
  markAllRead: () => void;
  clearNotifications: () => void;
}

let counter = 0;
const MAX_NOTIFICATIONS = 50;

export const useNotificationStore = create<NotificationState>()(
  devtools(
    persist(
      (set) => ({
        items: [],
        addNotification: (notification) => {
          const id = `notification-${Date.now()}-${++counter}`;
          set((state) => ({
            items: [
              {
                ...notification,
                id,
                createdAt: new Date().toISOString(),
                read: false,
              },
              ...state.items,
            ].slice(0, MAX_NOTIFICATIONS),
          }));
        },
        markAsRead: (id) =>
          set((state) => ({
            items: state.items.map((item) => (item.id === id ? { ...item, read: true } : item)),
          })),
        markAllRead: () =>
          set((state) => ({
            items: state.items.map((item) => ({ ...item, read: true })),
          })),
        clearNotifications: () => set({ items: [] }),
      }),
      { name: "uklid-notifications" },
    ),
    { name: "NotificationStore" },
  ),
);
